import React, { useState, useEffect } from 'react';
import { Dimensions, Platform } from '../../components/common';
import { StoreDetailsScreenDesktop } from './StoreDetailsScreenDesktop';
import { StoreDetailsScreenMobile } from './StoreDetailsScreenMobile';

export const StoreDetailsScreen = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const { width } = Dimensions.get('window');
      setIsDesktop(width >= 768); // Breakpoint for desktop vs mobile
    };

    // Initial check
    checkScreenSize();

    // Add event listener for window resize (web only)
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.addEventListener('resize', checkScreenSize);
      
      // Cleanup
      return () => {
        window.removeEventListener('resize', checkScreenSize);
      };
    }
  }, []);

  return isDesktop ? <StoreDetailsScreenDesktop /> : <StoreDetailsScreenMobile />;
};